<ion-content class="table-content">
  <app-dashboard-header (onSelected)="toggleFilterBody($event)" [filterComps]="filterComps" [filterObject]="filterObject"
                        [headerSetting]="headerSetting" [searchField]="searchField"
                        [showFilterBody]="showFilterBody">
    <ion-button *ngIf="canCreate" (click)="createObservation()" class="page-button" color="secondary"
                preSearchContent>{{ 'DASHPAGES.Create' | translate }}</ion-button>
  </app-dashboard-header>
  <div class="table-container dt-buttons-parent-element">
    <table class="display" id="coachingData"></table>
  </div>
</ion-content>
